import React from 'react';
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SaveProgressDialog = ({ open, progress }) => {
  const steps = [
    { key: 'event', label: 'Creating Event' },
    { key: 'scenarios', label: 'Creating Scenarios' },
    { key: 'attributes', label: 'Adding Attributes' },
  ];

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      sx={{
        '& .MuiDialog-paper': {
          minWidth: '400px',
        },
      }}
    >
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 2 }}>
          {progress === 'complete' ? (
            <>
              <CheckCircleIcon sx={{ fontSize: 48, color: 'success.main' }} />
              <Typography variant="h6">Save Complete!</Typography>
            </>
          ) : (
            <>
              <CircularProgress sx={{ color: 'primary.main' }} />
              <Typography variant="h6">Saving Event Configuration...</Typography>

              <Stepper
                activeStep={steps.findIndex((s) => s.key === progress)}
                sx={{ width: '100%' }}
              >
                {steps.map((step) => (
                  <Step key={step.key}>
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Typography variant="body2" color="text.secondary">
                Please wait while we save your configuration...
              </Typography>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SaveProgressDialog;
